/* SEQ Air Care indoor AC information page — no booking engine */
'use strict';

(function initSeqIndoorAcPage() {
  function start() {
    document.querySelectorAll('.seq-pdp--landing').forEach(section => {
      const mobileBar = section.querySelector('[data-mobile-booking-bar]');
      const heroActions = section.querySelector('.seq-ad-hero__actions');

      section.querySelectorAll('.seq-pdp-faq').forEach(item => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          section.querySelectorAll('.seq-pdp-faq[open]').forEach(other => {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });

      if (mobileBar) {
        const updateSticky = () => {
          const passedHero = window.scrollY > ((heroActions?.getBoundingClientRect().bottom || 0) + window.scrollY + 80);
          mobileBar.classList.toggle('is-visible', passedHero);
        };
        updateSticky();
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky, { passive: true });
      }
    });

    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-open-booking]');
      if (!trigger) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'seq_booking_cta_click',
        source: trigger.dataset.bookingSource || 'product_page',
        units: trigger.dataset.bookingUnits || '',
        outdoor: trigger.dataset.bookingOutdoor || ''
      });
      if (typeof window.clarity === 'function') window.clarity('event', 'seq_booking_cta_click');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
